import React from 'react';
import { Link } from 'react-router-dom';
import { FiClock, FiUser, FiArrowRight } from 'react-icons/fi';
import { getImageUrl } from '../utils/constants'; // Changed from IMAGE_BASE_URL

const RepairArticleCard = ({ article }) => {
  // Fixed image URL construction
  const imageUrl = article.images?.[0] 
    ? getImageUrl(article.images[0].filepath, 'repairs') // Use getImageUrl with repairs subfolder
    : 'https://via.placeholder.com/400x300/F3F4F6/9CA3AF?text=Repair+Service';
  
  const formattedDate = new Date(article.created_at).toLocaleDateString('km-KH', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  // Clean description from HTML tags
  const cleanDescription = article.description?.replace(/<[^>]*>/g, '').substring(0, 150) || '';

  return (
    <div className="bg-white border border-gray-200 hover:border-red-200 hover:shadow-sm transition-all">
      <Link to={`/repairs/${article.id}`} className="block">
        {/* Article Image */}
        <div className="relative overflow-hidden h-48 bg-gray-100">
          <img
            src={imageUrl}
            alt={article.title}
            className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://via.placeholder.com/400x300/F3F4F6/9CA3AF?text=Repair+Service";
            }}
          />
        </div>

        {/* Article Content */}
        <div className="p-5">
          <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2 hover:text-red-600 transition-colors">
            {article.title}
          </h3>
          
          <p className="text-gray-600 text-sm mb-4 line-clamp-3 leading-relaxed">
            {cleanDescription}
            {article.description?.length > 150 && '...'}
          </p>

          {/* Metadata */}
          <div className="flex items-center justify-between text-xs text-gray-500">
            <div className="flex items-center gap-3">
              {article.author && (
                <div className="flex items-center gap-1">
                  <FiUser className="w-3 h-3" />
                  <span>{article.author}</span>
                </div>
              )}
              <div className="flex items-center gap-1">
                <FiClock className="w-3 h-3" />
                <span>{formattedDate}</span>
              </div>
            </div>
            
            <span className="text-red-600 font-medium text-xs flex items-center gap-1 hover:gap-2 transition-all">
              អានបន្ថែម
              <FiArrowRight className="w-3 h-3" />
            </span>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default RepairArticleCard;